import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux"
import { useNavigate } from 'react-router-dom'
import { TextToSpeech } from '@capacitor-community/text-to-speech';
import { Capacitor } from '@capacitor/core';
import './Chatbot.css';
import './audioRecord.css'
import axios from 'axios';
import logo from './../img/logo.png';

function Chatbot() {
  const navigate = useNavigate();
  let situNum = useSelector((state) => state.situNum ) //聊天情景设置
  let [userMessage, setUserMessage] = useState([]);
  let [tutorMessage, setTutorMessage] = useState([]);
  let [userInput, setUserInput] = useState("");
  let [userAudioText, setUserAudioText] = useState([]); //存储用户语音输入的文本用于重播
  let [userAudioBlobs, setUserAudioBlobs] = useState([]); //存储用户语音输入的原始音频
  let [conversation, setConversation] = useState(null); //完整对话设置
  let [TTSVoice, setTTSVoice] = useState(null); //TTS语音设置
  let [availableVoices, setAvailableVoices] = useState([]); //可用语音列表
  let [nativeVoices, setNativeVoices] = useState([]); //原生平台可用语音列表
  let [feedback, setFeedback] = useState(null); //反馈设置
  let [isPlayingTTS, setIsPlayingTTS] = useState(false); //TTS播放状态
  let [isTTSReady, setIsTTSReady] = useState(false); //TTS是否已就绪
  let [inputMode, setInputMode] = useState('text'); // 'text' 或 'voice'
  //如果userMessage值更新则为true = sendMessage执行中为true，否则为false
  let [checkUpdate, setCheckUpdate] = useState(false);
  //是否在录音
  let [checkRecording, setCheckRecording] = useState(false);
  //麦克风连接检查
  const [isMicrophoneConnected, setIsMicrophoneConnected] = useState(false);
  const chatBoxRef = useRef(null);
  const currentAudioBlobRef = useRef(null); // 用于存储当前录音的blob
  const mediaRecorderRef = useRef(null); // MediaRecorder引用
  const feedbackBtn = "结束对话并获取反馈！💯";
  const situText = [
    "很高兴见到你！首先，你准备OPIc的哪个级别？",
    "Hi! It's great to see you again after such a long time. How have you been?",
    "Hey, it's great to see you at work today. How have you been doing lately?",
    "Hello, nice to meet you. Firstly, can you tell me a little bit about yourself?",
    "Hi, it's nice to meet you. How has your day been so far?",
    "Hi, it's nice to meet you. Could you please introduce about the topic of meeting?"
  ];

  //const num = [27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

  //麦克风设置
  useEffect(() => {
    async function checkMicrophoneConnection() {
      //麦克风连接检查
      const isWebRTCSupported = navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
      if (!isWebRTCSupported) {
        return;
      }
      //检查是否允许使用麦克风
      const isMicrophoneConnected = await navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
          stream.getTracks().forEach(track => track.stop());
          return true;
        })
        .catch(() => {
          return false;
        });
      setIsMicrophoneConnected(isMicrophoneConnected);
    }
    checkMicrophoneConnection();
  }, []);

  //初始化TTS语音
  useEffect(() => {
    const initializeVoices = async () => {
      if (Capacitor.isNativePlatform()) {
        // 原生平台：获取系统TTS语音列表
        try {
          const result = await TextToSpeech.getSupportedVoices();
          console.log('Native voices:', result.voices);
          if (result.voices && result.voices.length > 0) {
            // 过滤出英语语音并去重（只保留不同的音色类型）
            const enVoices = result.voices.filter(v => v.lang && v.lang.startsWith('en'));
            console.log('English voices:', enVoices);
            
            // 按voiceURI去重，保留每种音色的第一个
            const uniqueVoices = [];
            const seenVoiceTypes = new Set();
            
            for (const voice of enVoices) {
              // 提取音色类型代码（如tpc, tpd等）
              let voiceType = 'unknown';
              if (voice.voiceURI) {
                const match = voice.voiceURI.match(/-(tpc|tpd|tpf|iob|iom|cma|cmb|female|male)[-_]/i);
                if (match) {
                  voiceType = match[1].toLowerCase();
                }
              }
              
              if (!seenVoiceTypes.has(voiceType)) {
                seenVoiceTypes.add(voiceType);
                uniqueVoices.push(voice);
              }
            }
            
            console.log('Unique voices after dedup:', uniqueVoices);
            setNativeVoices(uniqueVoices);
            
            // 选择第一个语音
            const defaultVoice = uniqueVoices[0];
            setTTSVoice(defaultVoice);
            console.log('Selected native voice:', defaultVoice);
          } else {
            // 没有语音列表时使用默认
            setTTSVoice({ lang: 'en-US', name: 'Default' });
            console.log('Using default voice: en-US');
          }
          setIsTTSReady(true);
        } catch(e) {
          console.error('Failed to get native voices:', e);
          // 失败时使用默认
          setTTSVoice({ lang: 'en-US', name: 'Default' });
          setIsTTSReady(true);
        }
      } else if ('speechSynthesis' in window) {
        // Web平台：使用浏览器API
        const loadVoices = () => {
          const voices = window.speechSynthesis.getVoices();
          console.log('Available voices:', voices.length);
          if (voices.length > 0) {
            setAvailableVoices(voices);
            const enVoice = voices.find(v => v.lang.startsWith('en-US')) || 
                           voices.find(v => v.lang.startsWith('en')) || 
                           voices[0];
            setTTSVoice(enVoice);
            console.log('Selected voice:', enVoice.name, enVoice.lang);
            setIsTTSReady(true);
          } else {
            setTimeout(() => {
              const delayedVoices = window.speechSynthesis.getVoices();
              if (delayedVoices.length > 0) {
                setAvailableVoices(delayedVoices);
                const enVoice = delayedVoices.find(v => v.lang.startsWith('en-US')) || 
                               delayedVoices.find(v => v.lang.startsWith('en')) || 
                               delayedVoices[0];
                setTTSVoice(enVoice);
                console.log('Delayed selected voice:', enVoice.name, enVoice.lang);
                setIsTTSReady(true);
              }
            }, 1000);
          }
        };
        loadVoices();
        window.speechSynthesis.onvoiceschanged = loadVoices;
      } else {
        console.warn('speechSynthesis not supported');
      }
    };
    
    initializeVoices();
  }, [])

  //STT - 自定义录音和转录
  const [isRecording, setIsRecording] = useState(false);
  const [isTranscribing, setIsTranscribing] = useState(false);
  const [transcript, setTranscript] = useState({ text: '', blob: null });
  const mediaRecorderInstanceRef = useRef(null);
  const audioChunksRef = useRef([]);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderInstanceRef.current = mediaRecorder;
      audioChunksRef.current = [];

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorder.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
        currentAudioBlobRef.current = audioBlob;
        console.log('Audio blob captured:', audioBlob.size);
        
        // 转录音频
        await transcribeAudio(audioBlob);
        
        // 停止所有音轨
        stream.getTracks().forEach(track => track.stop());
      };

      mediaRecorder.start();
      setIsRecording(true);
      console.log('Recording started');
    } catch (error) {
      console.error('Error starting recording:', error);
      alert('无法访问麦克风');
    }
  };

  const stopRecording = () => {
    if (mediaRecorderInstanceRef.current && isRecording) {
      mediaRecorderInstanceRef.current.stop();
      setIsRecording(false);
      console.log('Recording stopped');
    }
  };

  const transcribeAudio = async (audioBlob) => {
    setIsTranscribing(true);
    try {
      const formData = new FormData();
      formData.append('file', audioBlob, 'audio.webm');

      const response = await fetch('https://englishtutor-backend.phoenix-yj.workers.dev/transcribe', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Transcription failed');
      }

      const data = await response.json();
      setTranscript({ text: data.text, blob: audioBlob });
      console.log('Transcription:', data.text);
    } catch (error) {
      console.error('Error transcribing audio:', error);
      alert('语音识别失败，请重试');
    } finally {
      setIsTranscribing(false);
    }
  };

  //TTS - 语音播放（原生插件版本）
  const TTS = async (tutorSpeak) => {
    if (!tutorSpeak) {
      console.log('TTS: No text to speak');
      return;
    }
    
    // 如果正在播放，等待一下
    if (isPlayingTTS) {
      console.log('TTS: Already playing, waiting...');
      await new Promise(resolve => setTimeout(resolve, 500));
    }
    
    try {
      setIsPlayingTTS(true);
      console.log('TTS: Starting speech synthesis');
      console.log('TTS: Platform:', Capacitor.getPlatform());
      console.log('TTS: Text length:', tutorSpeak.length);
      
      // 停止任何正在进行的语音
      if (Capacitor.isNativePlatform()) {
        // 使用原生TTS插件（Android/iOS）
        await TextToSpeech.stop();
        console.log('TTS: Using native plugin');
        
        console.log('TTS: Current TTSVoice object:', TTSVoice);
        console.log('TTS: TTSVoice.voiceURI:', TTSVoice?.voiceURI);
        console.log('TTS: TTSVoice.lang:', TTSVoice?.lang);
        console.log('TTS: TTSVoice.name:', TTSVoice?.name);
        
        const options = {
          text: tutorSpeak,
          lang: TTSVoice?.lang || 'en-US',
          rate: 1.0,
          pitch: 1.0,
          volume: 1.0,
          category: 'ambient'
        };
        
        // 尝试使用voiceURI作为voice参数
        if (TTSVoice?.voiceURI) {
          options.voice = TTSVoice.voiceURI;
          console.log('TTS: Setting voice to voiceURI:', TTSVoice.voiceURI);
        } else if (TTSVoice?.name) {
          options.voice = TTSVoice.name;
          console.log('TTS: Setting voice to name:', TTSVoice.name);
        }
        
        console.log('TTS: Final speaking options:', JSON.stringify(options, null, 2));
        await TextToSpeech.speak(options);
        console.log('TTS: Speech completed');
        setIsPlayingTTS(false);
      } else {
        // Web版本使用浏览器API
        console.log('TTS: Using browser speechSynthesis');
        
        if (!('speechSynthesis' in window)) {
          console.warn('TTS: speechSynthesis not supported');
          alert('你的设备不支持语音合成');
          setIsPlayingTTS(false);
          return;
        }
        
        window.speechSynthesis.cancel();
        await new Promise(resolve => setTimeout(resolve, 50));
        
        const utterance = new SpeechSynthesisUtterance(tutorSpeak);
        
        if (TTSVoice) {
          utterance.voice = TTSVoice;
          utterance.lang = TTSVoice.lang;
          console.log('TTS: Using voice:', TTSVoice.name, TTSVoice.lang);
        } else {
          utterance.lang = 'en-US';
        }
        
        utterance.pitch = 1.0;
        utterance.rate = 1.0;
        utterance.volume = 1.0;
        
        return new Promise((resolve, reject) => {
          utterance.onstart = () => {
            console.log('TTS: Speech started');
          };
          
          utterance.onend = () => {
            console.log('TTS: Speech completed');
            setIsPlayingTTS(false);
            resolve();
          };
          
          utterance.onerror = (event) => {
            console.error('TTS error:', event.error);
            setIsPlayingTTS(false);
            if (event.error !== 'interrupted' && event.error !== 'canceled') {
              reject(event);
            } else {
              resolve();
            }
          };
          
          window.speechSynthesis.speak(utterance);
        });
      }
    } catch(e) {
      console.error('TTS exception:', e);
      setIsPlayingTTS(false);
    }
  }

  // 播放用户录音的原始音频
  const playAudio = async (blob) => {
    if (!blob) {
      console.error('No audio blob to play');
      return;
    }
    try {
      const audioUrl = URL.createObjectURL(blob);
      const audio = new Audio(audioUrl);
      audio.play();
      audio.onended = () => {
        URL.revokeObjectURL(audioUrl);
      };
    } catch(e) {
      console.error('Audio playback error:', e);
    }
  }

  //播放初始情景消息
  useEffect(() => {
    if (isTTSReady && situNum !== null && situNum >= 0 && situNum <= 5 && situText[situNum]) {
      // 延迟一下确保DOM完全加载，避免与AI回复冲突
      setTimeout(() => {
        if (!isPlayingTTS) {
          TTS(situText[situNum]).catch(err => console.error('Initial TTS failed:', err));
        }
      }, 1500);
    } else if (isTTSReady && situNum === null) {
      setTimeout(() => {
        if (!isPlayingTTS) {
          TTS("Let's start conversation!").catch(err => console.error('Initial TTS failed:', err));
        }
      }, 1500);
    }
  }, [isTTSReady, situNum]);

  //向下滚动的代码
  useEffect(() => {
    chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
  }, [tutorMessage, userMessage]);

  //输入回车时更新userMessage并设置checkupdate为true
  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && userInput.trim()) {
      setUserMessage([...userMessage, userInput]);
      setUserAudioText([...userAudioText, null]); //文本输入没有语音
      setUserAudioBlobs([...userAudioBlobs, null]); //文本输入没有blob
      setCheckUpdate(true);
      setUserInput('');
    }
  }

  //点击按钮时使用
  function handleSendButton() {
    if (userInput.trim()) {
      setUserMessage([...userMessage, userInput]);
      setUserAudioText([...userAudioText, null]); //文本输入没有语音
      setUserAudioBlobs([...userAudioBlobs, null]); //文本输入没有blob
      setCheckUpdate(true);
      setUserInput('');
    }
  }

  //如果transcript.text存在（即录音完成），则更新UserMessage并将CheckUpdate设置为true的useEffect
  useEffect(() => {
    if (transcript.text) {
      setUserMessage([...userMessage, transcript.text]);
      setUserAudioText([...userAudioText, transcript.text]);
      // 存储录音blob（从ref获取）
      const audioBlob = currentAudioBlobRef.current || transcript.blob || null;
      setUserAudioBlobs([...userAudioBlobs, audioBlob]);
      console.log('Stored audio blob:', audioBlob ? audioBlob.size : 'null');
      // 清除ref
      currentAudioBlobRef.current = null;
      setCheckUpdate(true);
    }
  }, [transcript.text]);

  const sendMessage = async () => {
    try {
      const response = await axios.post('https://englishtutor-backend.phoenix-yj.workers.dev/tutoringSpeak', {
        situNum: situNum,
        userMessage: userMessage,
        tutorMessage: tutorMessage,
      }, {
        headers: {
          //'Access-Control-Allow-Origin': "https://englishtutor.pages.dev/",
          'Content-Type': 'application/json'
        }
      });
      const data = response.data;
      setTutorMessage([...tutorMessage, data.assistant]);
      setConversation(data.conversation); //更新完整对话内容
      await TTS(data.assistant);
    } catch (error) {
      console.error(error);
    }
  }

  //使用useEffect，当userMessage更新且checkUpdate为true时执行sendMessage
  useEffect(() => {
    if (checkUpdate) {
      sendMessage().then(() => {
        setCheckUpdate(false);
        transcript.text = null;
      });
    }
  }, [checkUpdate]);

  //将tutor和user消息按顺序整合到message中，以便在聊天UI中显示
  let messages = [];
  let userIndex = 0;
  let tutorIndex = 0;
  while (userIndex < userMessage.length && tutorIndex < tutorMessage.length) {
    if (userIndex <= tutorIndex) {
      messages.push(userMessage[userIndex]);
      userIndex++;
    } else {
      messages.push(tutorMessage[tutorIndex]);
      tutorIndex++;
    }
  }
  messages = messages.concat(userMessage.slice(userIndex)).concat(tutorMessage.slice(tutorIndex));

  const getFeedback = async () => {
    try {
      const response = await axios.post('https://englishtutor-backend.phoenix-yj.workers.dev/getFeedback', {
        conversation: conversation,
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const data = response.data;
      setFeedback(data.feedback); //设置获取的反馈
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <div className="chat-container">
      <h1 className="chat-title">AI英语家教</h1>
      <img className="chat-logo" onClick={() => { navigate('/'); }} src={logo} alt="logoImg"/>
      
      {/* 语音选择器 */}
      {!Capacitor.isNativePlatform() && (
        <div style={{ padding: '10px', textAlign: 'center' }}>
          <label style={{ marginRight: '10px', color: 'white' }}>选择语音：</label>
          <select 
            value={TTSVoice?.name || ''} 
            onChange={(e) => {
              const selected = availableVoices.find(v => v.name === e.target.value);
              if (selected) {
                setTTSVoice(selected);
                console.log('Voice changed to:', selected.name, selected.lang);
              }
            }}
            style={{ 
              padding: '5px 10px', 
              borderRadius: '5px',
              border: '1px solid #ccc'
            }}
          >
            {availableVoices.filter(v => v.lang.startsWith('en')).map(voice => (
              <option key={voice.name} value={voice.name}>
                {voice.name} ({voice.lang})
              </option>
            ))}
          </select>
        </div>
      )}
      {Capacitor.isNativePlatform() && nativeVoices.length > 0 && (
        <div style={{ padding: '10px', textAlign: 'center' }}>
          <label style={{ marginRight: '10px', color: 'white' }}>选择音色：</label>
          <select 
            value={TTSVoice?.voiceURI || TTSVoice?.lang || ''} 
            onChange={(e) => {
              const selected = nativeVoices.find(v => (v.voiceURI || v.lang) === e.target.value);
              if (selected) {
                setTTSVoice(selected);
                console.log('Voice changed to:', selected);
                console.log('New voice voiceURI:', selected.voiceURI);
                console.log('New voice lang:', selected.lang);
              }
            }}
            style={{ 
              padding: '5px 10px', 
              borderRadius: '5px',
              border: '1px solid #ccc'
            }}
          >
            {nativeVoices.map((voice, idx) => {
              // 音色友好名称映射
              const friendlyNames = {
                'tpc': '男声 1',
                'tpd': '女声 1', 
                'tpf': '女声 2',
                'iob': '男声 2',
                'iom': '男声 3',
                'cma': '女声',
                'cmb': '男声',
                'female': '女声',
                'male': '男声'
              };
              
              let displayName = '未知音色';
              
              // 处理Android native voices的voiceURI格式 (如: en-us-x-tpc-local, en-gb-x-tpd-local)
              if (voice.voiceURI) {
                const voiceURI = voice.voiceURI.toLowerCase();
                // 提取音色代码
                for (const [code, name] of Object.entries(friendlyNames)) {
                  if (voiceURI.includes(`-${code}-`) || voiceURI.includes(`-${code}`)) {
                    displayName = name;
                    break;
                  }
                }
              }
              
              return (
                <option key={voice.voiceURI || voice.lang || idx} value={voice.voiceURI || voice.lang}>
                  {displayName}
                </option>
              );
            })}
          </select>
        </div>
      )}
      
      <div className="chat-box" ref={chatBoxRef}>
        <div className="chat-message tutor">
          {
            situNum === null
              ? (
                <>
                  <p>Let's start conversation!</p>
                  <button 
                    className="replay-btn" 
                    onClick={() => TTS("Let's start conversation!")}
                    title="重播语音"
                    style={{
                      marginLeft: '10px',
                      padding: '5px 10px',
                      border: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      fontSize: '18px'
                    }}
                  >
                    🔊
                  </button>
                </>
              )
              : situNum >= 0 && situNum <= 5
                ? (
                  <>
                    <p>{situText[situNum]}</p>
                    <button 
                      className="replay-btn" 
                      onClick={() => TTS(situText[situNum])}
                      title="重播语音"
                      style={{
                        marginLeft: '10px',
                        padding: '5px 10px',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        fontSize: '18px'
                      }}
                    >
                      🔊
                    </button>
                  </>
                )
                : null
          }
        </div>
        {messages.map((message, index) => (
          <div className={`chat-message ${index % 2 === 0 ? 'user' : 'tutor'}`} key={index}>
            <p>{message}</p>
            {/* 用户消息: 只有语音输入才显示重播按钮 */}
            {index % 2 === 0 && userAudioText[Math.floor(index / 2)] && (
              <button 
                className="replay-btn" 
                onClick={() => {
                  const audioIndex = Math.floor(index / 2);
                  // 如果有原始录音blob，播放原始音频；否则使用TTS
                  if (userAudioBlobs[audioIndex]) {
                    playAudio(userAudioBlobs[audioIndex]);
                  } else {
                    TTS(message);
                  }
                }}
                title="重播语音"
                style={{
                  marginLeft: '10px',
                  padding: '5px 10px',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  fontSize: '18px'
                }}
              >
                🔊
              </button>
            )}
            {/* AI消息: 始终显示重播按钮 */}
            {index % 2 !== 0 && (
              <button 
                className="replay-btn" 
                onClick={() => TTS(message)}
                title="重播语音"
                style={{
                  marginLeft: '10px',
                  padding: '5px 10px',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  fontSize: '18px'
                }}
              >
                🔊
              </button>
            )}
          </div>
        ))}
      </div>
      
      {/*输入框区域 - 微信风格*/}
      <div className="chat-input" style={{ display: 'flex', alignItems: 'center', padding: '10px', background: 'white', borderBottomLeftRadius: '5px', borderBottomRightRadius: '5px' }}>
        {inputMode === 'text' ? (
          <>
            {isMicrophoneConnected && (
              <button 
                onClick={() => setInputMode('voice')}
                style={{
                  background: '#f5f5f5',
                  border: '1px solid #ddd',
                  padding: '10px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '18px',
                  width: '45px',
                  height: '45px',
                  marginRight: '10px'
                }}
                title="切换到语音输入"
              >
                🎤
              </button>
            )}
            <input 
              type="text" 
              placeholder="Type your message here..." 
              value={userInput} 
              onChange={(e) => setUserInput(e.target.value)} 
              onKeyPress={handleKeyPress}
              style={{ flex: 1, padding: '10px', border: 'none', outline: 'none' }}
            />
            <button 
              onClick={handleSendButton}
              style={{
                background: '#13a833',
                color: '#fff',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold',
                marginLeft: '5px'
              }}
            >
              Send
            </button>
          </>
        ) : (
          <>
            <button 
              onClick={() => setInputMode('text')}
              style={{
                background: '#f5f5f5',
                border: '1px solid #ddd',
                padding: '10px',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px',
                marginRight: '10px',
                height: '45px',
                width: '45px'
              }}
              title="切换到文字输入"
            >
              📝
            </button>
            {checkUpdate ? (
              <button 
                disabled
                style={{
                  flex: 1,
                  background: '#ddd',
                  color: '#999',
                  border: 'none',
                  padding: '12px',
                  borderRadius: '5px',
                  fontSize: '16px',
                  cursor: 'not-allowed'
                }}
              >
                AI导师正在回答中...
              </button>
            ) : checkRecording ? (
              <button 
                onMouseUp={() => { stopRecording(); setCheckRecording(false); }}
                onTouchEnd={(e) => { e.preventDefault(); stopRecording(); setCheckRecording(false); }}
                style={{
                  flex: 1,
                  background: '#ff4444',
                  color: 'white',
                  border: 'none',
                  padding: '12px',
                  borderRadius: '5px',
                  fontSize: '16px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  userSelect: 'none',
                  WebkitUserSelect: 'none',
                  WebkitTouchCallout: 'none'
                }}
              >
                🔴 松开 结束
              </button>
            ) : (
              <button 
                onMouseDown={() => { setCheckRecording(true); startRecording(); }}
                onTouchStart={(e) => { e.preventDefault(); setCheckRecording(true); startRecording(); }}
                style={{
                  flex: 1,
                  background: '#13a833',
                  color: 'white',
                  border: 'none',
                  padding: '12px',
                  borderRadius: '5px',
                  fontSize: '16px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  userSelect: 'none',
                  WebkitUserSelect: 'none',
                  WebkitTouchCallout: 'none'
                }}
              >
                按住 说话
              </button>
            )}
          </>
        )}
      </div>

      {/*旧的语音录制按钮 - 已废弃*/}
      <div style={{ display: 'none' }}>
        { isMicrophoneConnected ? (
                checkUpdate ? (
                  <div className="recordBtnBox">
                    <p>AI导师正在回答中！</p>
                    <button className="recordStartBtn" disabled="disabled" onClick={() => { setCheckRecording(true); startRecording();  }}>Speak!</button>
                  </div>
                ) : (
                  <div>
                    { checkRecording ? (
                        <div className="recordBtnBox">
                          <button  className="recordStopBtn" onClick={() => { stopRecording(); setCheckRecording(false); }}>Stop</button>
                        </div>
                    ) : (
                      <div className="recordBtnBox">
                        <button className="recordStartBtn" onClick={() => { setCheckRecording(true); startRecording();  }}>Speak!</button>
                      </div>
                    )}
                  </div>
                )
          ) : null
        }
      </div>




      <div>
        <button className="mainBtn" onClick={getFeedback}>{feedbackBtn}</button>
      </div>
      <div>
        {feedback && <div className='Feedback' dangerouslySetInnerHTML={{ __html: feedback.replace(/<h3/g, '<h4 class="feedback-h4"').replace(/<h4/g, '<h4 class="feedback-h4"').replace(/<ul/g, '<ul class="feedback-ul"').replace(/<li/g, '<li class="feedback-li"') }} />}
      </div>
      </div>
  );
}

export default Chatbot;